import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-file-remove",
  templateUrl: "./med-icon-file-remove.component.html",
})
export class MedIconFileRemoveComponent extends SvgMixinComponent {}
